import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@tempo-io/sui-sonner';
import { useTranslation } from 'react-i18next';
import { CustomFieldsApi } from '@/lib/api/common/customFields';
import type { UpdateCustomField } from '@/lib/api/types/customField';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const useUpdateCustomFieldMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ customFieldId, data }: { customFieldId: number; data: UpdateCustomField }) =>
      CustomFieldsApi.patchCustomField({
        customFieldId,
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: commonQueryKeys.customFields.all(),
      });
      queryClient.invalidateQueries({
        queryKey: commonQueryKeys.itemTypes.all,
      });
    },
    onError: (error) => {
      toast.error(
        t(($) => $.common.settings.customFields.errorUpdatingCustomField),
        {
          description: error.message,
        },
      );
    },
  });
};
